import { render, staticRenderFns } from "./task-refuse-calc.vue?vue&type=template&id=7b450c21&scoped=true"
import script from "./task-refuse-calc.vue?vue&type=script&lang=js"
export * from "./task-refuse-calc.vue?vue&type=script&lang=js"
import style0 from "./task-refuse-calc.vue?vue&type=style&index=0&id=7b450c21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b450c21",
  null
  
)

export default component.exports